// extracted by mini-css-extract-plugin
export default {"Modal":"Style_Modal__VFrfR","Cont":"Style_Cont__BY4mL"};